<template>
  <div class="issues-app-main-chat">
    <chat-selected-message-actions
      :message="selectedMessage"
      :is-message-last="isSelectedMessageLast"
      @cancel="onCancelSelectMessage"
      @delete="onDeleteMessage"
    />
    <VuePerfectScrollbar
      ref="scroll"
      class="issues-app-main-chat__scroll"
    >
      <div v-if="isLoading || !taskData">

      </div>
      <div class="issues-app-main-chat__no-data" v-else-if="!taskData.length">
        Сообщений пока нет
      </div>
      <div v-else>
        <template v-for="(item, index) in taskData">
          <history-item v-if="item.isHistory" :item="item" :key="index" />
          <chat-item
            v-else-if="item.isChat"
            :item="item"
            :key="index"
            :selectable="isMessageSelectable(item)"
            :selected="isMessageSelected(item)"
            @select="onSelectMessage"
          />
          <file-item
            v-else-if="item.isFile"
            :item="item"
            :key="index"
            :selectable="isMessageSelectable(item)"
            :selected="isMessageSelected(item)"
            @select="onSelectMessage"
          />
        </template>
      </div>
    </VuePerfectScrollbar>
  </div>
</template>

<script>
import ChatSelectedMessageActions from "@/components/common/issues/main/chat/ChatSelectedMessageActions";
import VuePerfectScrollbar        from 'vue-perfect-scrollbar';
import HistoryItem                from "./chat/HistoryItem";
import ChatItem                   from "./chat/ChatItem";
import FileItem                   from "./chat/FileItem";
import StarRating                 from 'vue-star-rating';

export default {
  name:       "IssuesMainChat",
  components: {
    ChatSelectedMessageActions,
    VuePerfectScrollbar,
    HistoryItem,
    ChatItem,
    FileItem,
    StarRating,
  },
  data() {
    return {
      selectedMessage: null,
    };
  },
  props:    {
    taskData:     {
      default() {
        return [];
      },
    },
    selectedTask: {
      default() {
        return {};
      },
    },
    canRate:      {
      type:    Boolean,
      default: false,
    },
    isLoading:    {
      type:    Boolean,
      default: false,
    },
  },
  computed: {
    issueRating: {
      get() {
        return null;
      },
      set( v ) {
        this.updateTask('rate', v);
      },
    },
    currentUserId() {
      return this.$store.getters['appUser/id'];
    },
    currentUserType() {
      return this.$store.getters['appUser/type'];
    },

    isSelectedMessageLast() {
      const { selectedMessage, taskData } = this;
      if (!selectedMessage) return false;
      return taskData.findIndex(item => item.id === selectedMessage.id) === taskData.length - 1;
    },
  },
  methods:  {
    scrollDown() {
      this.$nextTick(() => {
        if (this.$refs.scroll) {
          this.$refs.scroll.$el.scrollTop = this.$refs.scroll.$el.scrollHeight;
        }
      });
    },
    updateTask( key, value ) {
      this.$emit('save', {
        key:   key,
        value: value,
      });
    },

    isMessageSelectable( message ) {
      return message.user && this.currentUserType === message.user.type_user;
    },

    isMessageSelected( message ) {
      return this.selectedMessage && this.selectedMessage.id === message.id;
    },

    onSelectMessage( message ) {
      if (this.selectedMessage && this.selectedMessage.id === message.id) {
        this.selectedMessage = null;
      } else {
        this.selectedMessage = message;
      }
    },

    onCancelSelectMessage() {
      this.selectedMessage = null;
    },

    onDeleteMessage() {
      const { selectedMessage } = this;
      if (!selectedMessage) return;
      if (selectedMessage.isFile) {
        this.$emit('deleteFile', selectedMessage);
      } else if (selectedMessage.isChat) {
        this.$emit('deleteMessage', selectedMessage);
      }
      this.selectedMessage = null;
    },
  },
};
</script>

<style lang="scss">
.issues-app-main-chat {
  position: relative;
  flex: 1;
  overflow: hidden;

  &__scroll {
    padding: 15px 0;
    height: 100%;
  }

  &__no-data {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }


  &__rate {
    border: 1px solid #eee;
    background: #fff;
    box-shadow: 0 10px 12px rgba(0, 0, 0, .2);
    padding: 10px 15px;
    text-align: center;
    border-radius: 4px;
    line-height: 1.1;

    &-wrapper {
      position: sticky;
      bottom: -15px;
      display: flex;
      justify-content: center;
      align-items: center;
      left: 0;
      right: 0;
      padding: 15px 5px;
    }

    &-header {
      margin-bottom: 5px;
    }

    &-rating {
      justify-content: center;
      display: flex;
    }

    &-add-new {
      margin-bottom: 0;

      &:hover {
        cursor: pointer;
        text-decoration: underline;
        color: rgba(var(--app-primary), 1);
      }
    }

  }
}

.app-context {

  &.v-context {
    background: #fff;
    border: 1px solid rgba(0, 0, 0, .1);
    border-radius: 2px;
    box-shadow: 0 1px 6px 1px rgba(69, 65, 78, .1);
    width: 150px;

    li {
      list-style: none;
      padding: 8px 10px;
      font-size: 1rem;
      display: flex;
      align-items: center;
      cursor: pointer;

      &:hover {
        background: #f5f8fa;
      }
    }
  }

  &__icon {
    margin-right: 5px;
  }

  &__text {
    font-size: .85rem;
    line-height: 1;
  }
}
</style>
